import {useProductQuery} from './useProductsQuery';

// Single-record read for the detail page.
export const useProduct = (id: string) => {
    const query = useProductQuery(id);

    return {
        record: query.data ?? undefined,
        loading: query.isLoading,
        isError: query.isError,
        notFound: query.isFetched && !query.data,
    };
};
